/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NutritionAndDietResponseDto
 */
export interface NutritionAndDietResponseDto {
    /**
     * Identity of the Nutrition and Diet
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    id: string;
    /**
     * Patient identity
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    patientId: string;
    /**
     * Diet type
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    dietType: string;
    /**
     * Breakfast
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    breakfast: string;
    /**
     * Lunch
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    lunch: string;
    /**
     * Dinner
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    dinner: string;
    /**
     * Snacks or beverages
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    snacksOrBeverages: string;
    /**
     * Water amount(number) per day
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    waterPerDay: string;
    /**
     * Food insensitivities
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    foodInsensitivities: string;
    /**
     * Other diet type
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    otherDietType?: string;
    /**
     * Daily meals
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    dailyMeals?: string;
    /**
     * Sources of hydration
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    hydrationSources?: string;
    /**
     * Additional information
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    additionalInformation: string;
    /**
     * Last updated timestamp
     * @type {string}
     * @memberof NutritionAndDietResponseDto
     */
    lastUpdated: string;
}

/**
 * Check if a given object implements the NutritionAndDietResponseDto interface.
 */
export function instanceOfNutritionAndDietResponseDto(value: object): value is NutritionAndDietResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('dietType' in value) || value['dietType'] === undefined) return false;
    if (!('breakfast' in value) || value['breakfast'] === undefined) return false;
    if (!('lunch' in value) || value['lunch'] === undefined) return false;
    if (!('dinner' in value) || value['dinner'] === undefined) return false;
    if (!('snacksOrBeverages' in value) || value['snacksOrBeverages'] === undefined) return false;
    if (!('waterPerDay' in value) || value['waterPerDay'] === undefined) return false;
    if (!('foodInsensitivities' in value) || value['foodInsensitivities'] === undefined) return false;
    if (!('additionalInformation' in value) || value['additionalInformation'] === undefined) return false;
    if (!('lastUpdated' in value) || value['lastUpdated'] === undefined) return false;
    return true;
}

export function NutritionAndDietResponseDtoFromJSON(json: any): NutritionAndDietResponseDto {
    return NutritionAndDietResponseDtoFromJSONTyped(json, false);
}

export function NutritionAndDietResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NutritionAndDietResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'dietType': json['dietType'],
        'breakfast': json['breakfast'],
        'lunch': json['lunch'],
        'dinner': json['dinner'],
        'snacksOrBeverages': json['snacksOrBeverages'],
        'waterPerDay': json['waterPerDay'],
        'foodInsensitivities': json['foodInsensitivities'],
        'otherDietType': json['otherDietType'] == null ? undefined : json['otherDietType'],
        'dailyMeals': json['dailyMeals'] == null ? undefined : json['dailyMeals'],
        'hydrationSources': json['hydrationSources'] == null ? undefined : json['hydrationSources'],
        'additionalInformation': json['additionalInformation'],
        'lastUpdated': json['lastUpdated'],
    };
}

export function NutritionAndDietResponseDtoToJSON(json: any): NutritionAndDietResponseDto {
    return NutritionAndDietResponseDtoToJSONTyped(json, false);
}

export function NutritionAndDietResponseDtoToJSONTyped(value?: NutritionAndDietResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'dietType': value['dietType'],
        'breakfast': value['breakfast'],
        'lunch': value['lunch'],
        'dinner': value['dinner'],
        'snacksOrBeverages': value['snacksOrBeverages'],
        'waterPerDay': value['waterPerDay'],
        'foodInsensitivities': value['foodInsensitivities'],
        'otherDietType': value['otherDietType'],
        'dailyMeals': value['dailyMeals'],
        'hydrationSources': value['hydrationSources'],
        'additionalInformation': value['additionalInformation'],
        'lastUpdated': value['lastUpdated'],
    };
}

